











































import {Vue, Component, Prop} from 'vue-property-decorator';
import {Util} from '@/utils';
import AppCenterService from "@service/app/app-center-service";

/**
 * 开发模式控制行为组
 *
 * @export
 * @class AppDebugActions
 * @extends {Vue}
 */
@Component({})
export default class AppChangePassword extends Vue {
  /**
   * 修改密码弹窗
   */
  public modalVisible: boolean = false;
  public isPassWord: boolean = true;
  public isPassWordConfirm: boolean = true;
  private ssoCode: String | undefined;
  private loginName: String | undefined;

  // 是否允许关闭
  public canClose: boolean = true;
  public passwordForm = {
    newPassWord: "",
    confirmPassword: ""
  }

  public checkPassWord(rule: any, value: any, callback: any) {
    let reg: any = /^[a-zA-Z]+$/
    let req_: any = /^[0-9]+$/
    if (value) {
      if (reg.test(value) || req_.test(value) || value.length < 8) {
        callback(new Error("密码过于简单！密码长度不能少于8位，不能全为数字或者字母"));
      } else {
        callback();
      }
    }
  }

  public passwordRule = {
    newPassWord: [
      {required: true, message: '新密码不能为空', trigger: 'blur'},
      {validator: this.checkPassWord, trigger: "change"}
    ],
    confirmPassword: [
      {required: true, message: '确认密码不能为空', trigger: 'blur'},
      {validator: this.checkPassWord, trigger: "change"}
    ],
  }

  public passowordClick() {
    this.isPassWord = !this.isPassWord
  }

  public isPassWordConfirmClick() {
    this.isPassWord = true;
    this.isPassWordConfirm = true;
    this.isPassWordConfirm = !this.isPassWordConfirm;
  }

  public onVisibleChange() {
    const refs = (this.$refs) as any;
    refs.passwordFormRef.resetFields();
  }

  public changePassWordConfirm() {
    // @ts-ignore
      const user:any=JSON.parse(localStorage.getItem('user'))
      const loginName:any=user.loginName
      if(loginName[0]!=='F'){
        this.$Message.error({
              content: '修改密码失效，请到OA修改密码。',
              duration: 5,
              closable: true
            });
        return
      }
    const refs = (this.$refs) as any;
    refs.passwordFormRef.validate((valid: boolean) => {
      if (valid) {
        // 验证两次输入的密码是否相同
        if (this.passwordForm.newPassWord != this.passwordForm.confirmPassword) {
          this.$Message.error('两次密码输入不相同，请重新输入');
          return;
        }
        if (this.ssoCode) {
          const url = '/runtimeapi/v7/changePasswordBySsoCode?ssoCode=' + this.ssoCode + '&loginName=' + this.loginName;
          const post: Promise<any> = this.$http.post(url, this.passwordForm.newPassWord, true);
          post.then((res: any) => {
            this.modalVisible = false;
            this.canClose = true;
            sessionStorage.removeItem("changepassword");
            this.$Message.success('密码修改成功,请重新使用新密码登录!');
          }).catch(err => {
            this.$Message.error('密码修改失败!' + err.getMessage());
          })
        }
        const post: Promise<any> = this.$http.post('/runtimeapi/v7/changePassword', this.passwordForm.newPassWord, true);
        post.then((res: any) => {
          sessionStorage.setItem('token', res.data);
          // Util.setCookie('sysuaa-token', res.data, 0);
          document.cookie = 'sysuaa-token' + "=" + escape(res.data) + ';path=/';
          this.modalVisible = false;
          this.canClose = true;
          this.$Message.success('密码修改成功!');
          sessionStorage.removeItem("changepassword");
        }).catch(err => {
          debugger
          this.$Message.error('密码修改失败：' + err.data.message);
        })

      }
    })
  }
  public showTip:any=false //内部账号显示提示文字
  public mounted() {
    // @ts-ignore
      const user:any=JSON.parse(localStorage.getItem('user'))
      const name:any=user.loginName
      if(name[0]!=='F') this.showTip=true
    AppCenterService.getMessageCenter().subscribe(({name, action, data}) => {
      if (Object.is(name, 'isFirstLogin')) {
        if (data && data.modalVisible) {
          this.modalVisible = true;
          this.canClose = data.canClose;
          if (data.loginName && data.ssoCode) {
            this.loginName = data.loginName;
            this.ssoCode = data.ssoCode;
          }
        }
      }
    });
  }

}
